/** @format */

import $ from "jquery";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import React, { useEffect, useState, useRef } from "react";
import { CloseOutlined } from "@ant-design/icons";

import pdf from "../../../../icons/pdf.png";
import Card from "../../../../components/Card";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import Minimap from "../../../../components/map/Minimap";
import Chart2 from "../../../../components/Charts/Chart2";
import { header } from "../../../../components/api/Header";
import LoadingCard from "../../../../components/loading/loadingCard";
import { ExcelPrint, Pdf } from "../../../../components/functions/Print";
import { getEnv } from "../../../../lib/env";
import { formatTableValue } from "./formatTableValue";

function Yillik({ region, regionId, vaqt, itbId, periodTabs, endpoint }) {
  const conponentPDF = useRef();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState("");

  const [year, setYear] = useState(new Date().toISOString().slice(0, 4));
  const [lyear, setLyear] = useState(year);

  useEffect(() => {
    let active = true;
    const fetchData = async () => {
      setLoading(true);
      try {
        const requestUrl = endpoint
          ? getEnv('REACT_APP_BASE_URL') + endpoint + "?year=" + year
          : getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/asosiymanbalar/yillik?regionId=" +
            regionId +
            "&year=" +
            year +
            "&vaqt=" +
            vaqt;
        const res = await axios.get(requestUrl,
          endpoint ? header() : { ...header(), params: { itbId } });

        if (active) setData(res.data);
      } catch (e) {
        if (!active) return;
        setData([]);
        console.log("Xato", e);
        alert("Serverga ulanishda xato!");
      } finally {
        if (active) setLoading(false);
      }
    };
    fetchData();
    return () => { active = false; };
  }, [year, regionId, vaqt, itbId, endpoint]);

  useEffect(() => {
    close();
  }, [regionId, itbId]);

  useEffect(() => {
    setYear(lyear);
  }, [lyear]);

  const chiz = (index) => {
    removeChecked();
    let v = $("tr.tr" + index + " input");
    let checked = v[0].checked;
    v[0].checked = !checked;
    if (!checked) {
      $("tr.tr" + index).addClass("active");
    } else {
      $("tr.tr" + index).removeClass("active");
    }
    setSelectedRowKeys(index);
  };

  const removeChecked = () => {
    if (selectedRowKeys !== "") {
      const checkbox = $("tr.tr" + selectedRowKeys + " input")[0];
      if (checkbox) checkbox.checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
  };

  const close = () => {
    if (selectedRowKeys !== "") {
      const checkbox = $("tr.tr" + selectedRowKeys + " input")[0];
      if (checkbox) checkbox.checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
    setSelectedRowKeys("");
  };

  const labels = [year, year - 1, year - 2, year - 3, year - 4];

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  return (
    <>
      <div className='table-box'>
        <div className='table-content-top'>
          <div className='table-top-left'>
            {periodTabs}
          </div>

          <ul className='table-top-right'>
            <li>
              <div className='d-flex'>
                <input
                  type='number'
                  className='form-control form-control-sm'
                  value={lyear}
                  onChange={(e) => setLyear(e.target.value)}
                />
              </div>
            </li>

            <li>
              <button className='btn p-0' onClick={() => generatePDF()}>
                <img src={print} alt='404' />
              </button>
            </li>

            <li>
              <button onClick={() => Pdf("tblData")} className='btn p-0'>
                <img src={pdf} alt='404' />
              </button>
            </li>

            <li>
              <button
                className='btn p-0'
                onClick={() =>
                  ExcelPrint("Asosiy manbalar " + region, year, "tblData")
                }>
                <img src={excel} alt='404' />
              </button>
            </li>
          </ul>
        </div>

        {loading ? (
          <LoadingCard loading={loading} heightSize='80vh' />
        ) : (
          <div id='content'>
            <div
              id='tableFlexible'
              style={{ height: selectedRowKeys === "" ? "80vh" : "35vh" }}>
              <div ref={conponentPDF} style={{ width: "100%" }}>
                <table
                  id='tblData'
                  className='table table-bordered table-style fixedHeader'>
                  <thead className=''>
                    <tr>
                      <th className='sticky st1'>o</th>

                      <th
                        className='sticky'
                        style={{ left: "31px", padding: "15px 0" }}>
                        T/R
                      </th>

                      <th
                        className='sticky'
                        style={{ left: "71px", width: "250px" }}>
                        Irrigatsiya tizimlari nomi va asosiy suvolish nuqtalari
                      </th>

                      <th className='sticky' style={{ left: "368px" }}>
                        O’lchov birligi
                      </th>

                      <th className='text-center'>{year}</th>
                      <th className='text-center'>{year - 1}</th>
                      <th className='text-center'>{year - 2}</th>
                      <th className='text-center'>{year - 3}</th>
                      <th className='text-center'>{year - 4}</th>
                    </tr>
                  </thead>

                  {data.length > 0
                    ? data.map((d, index) => {
                        return (
                          <tbody key={index}>
                            <tr
                              onClick={() => chiz(index)}
                              className={"tr tr" + index}>
                              <td
                                className='sticky st1'
                                style={{
                                  width: 50,
                                }}>
                                <input type='checkbox' />
                              </td>

                              <td
                                className='sticky'
                                style={{ left: "31px", width: 50 }}>
                                {index + 1}
                              </td>

                              <td
                                className={
                                  d.lat != "" && d.lan != ""
                                    ? "text-start sticky fix-with haslocation"
                                    : "text-start sticky fix-with"
                                }
                                style={{ left: "71px" }}>
                                {d.manba_nomi}
                              </td>

                              <td
                                className='text-center sticky'
                                style={{ left: "368px", width: "80px" }}>
                                {d.birligi}
                              </td>

                              {/* {d.data
                                ? d.data.map((s, i) => {
                                    const val = parseFloat(s);
                                    const displayValue =
                                      !isNaN(val) && val !== null
                                        ? val % 1 === 0
                                          ? val
                                          : val.toFixed(1)
                                        : s;

                                    return (
                                      <td
                                        style={{
                                          width: 120,
                                        }}
                                        key={i}>
                                        {displayValue}
                                      </td>
                                    );
                                  })
                                : Array(5)
                                    .fill()
                                    .map((_, i) => (
                                      <td
                                        style={{
                                          width: 120,
                                        }}
                                        key={i}></td>
                                    ))} */}

                              {d.data
                                ? d.data.map((s, i) => {
                                    const years = year - i;
                                    const val = parseFloat(s);

                                    const daysInYear =
                                      (years % 4 === 0 && years % 100 !== 0) ||
                                      years % 400 === 0
                                        ? 366
                                        : 365;

                                    const avgValue =
                                      s !== null && s !== undefined && s !== "" && !isNaN(val)
                                        ? formatTableValue(val / daysInYear)
                                        : "-";

                                    return (
                                      <td
                                        style={{
                                          width: 120,
                                          textAlign: "center",
                                        }}
                                        key={years}>
                                        {avgValue}
                                      </td>
                                    );
                                  })
                                : Array(5)
                                    .fill()
                                    .map((_, i) => (
                                      <td
                                        style={{
                                          width: 120,
                                        }}
                                        key={i}>-</td>
                                    ))}
                            </tr>
                          </tbody>
                        );
                      })
                    : null}
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      {selectedRowKeys.length === 0 ? null : (
        <div
          className='data-content mt-3 mainpage'
          style={{ position: "relative" }}>
          <CloseOutlined
            style={{
              position: "absolute",
              top: 0,
              right: 10,
              zIndex: 9,
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={close}
          />

          <Card>
            {data[selectedRowKeys].lat !== null &&
            data[selectedRowKeys].lan !== null ? (
              <Minimap
                location={[
                  data[selectedRowKeys].lat,
                  data[selectedRowKeys].lan,
                ]}
                locations={[]}
                zoom={13}
              />
            ) : null}
          </Card>

          <Chart2 datas={data[selectedRowKeys]["data"]} labels={labels} />
        </div>
      )}
    </>
  );
}

export default Yillik;
